<div class="container-nav">
  <ul ngbNav [(activeId)]="activeId" class="container-nav__tabs nav-tabs" #nav="ngbNav" [animation]="true"
    [destroyOnHide]="true">
    <li *ngFor="let item of block; let idx = index" [ngbNavItem]="idx" class="container-nav__tabs__items">
      <a ngbNavLink class="container-nav__tabs__items__text-tab ls-label-small-semibold">{{ item.tab_label |
        uppercase}}</a>
      <ng-template ngbNavContent>
        <div [innerHTML]="helpersService.modifyLinks(item.testo_formattato, domainWebsite) | safeHtml" class="container-nav__tabs__items__text-description"></div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class=""></div>
</div>